<template>
  <div class="col date-container">
    <label v-if="isMobile">{{$t('message.dateAndTime.date')}}</label>
    <VueCtkDateTimePicker
      :label="$t('message.dateAndTime.enterDate')"
      noLabel="true"
      :locale="$i18n.locale"
      onlyDate="true"
      noButton="true"
      noClearButton="true"
      noKeyboard="true"
      noShortcuts="true"
      :inline="!isMobile"
      format="YYYY-MM-DD"
      formatted="LL"
      noHeader="true"
      auto-close="true"
      dark="true"
      color="#3fa9f5"
      v-model="inputVal"
    />
  </div>
</template>

<script>
export default {
  props: ["value", "valid", "isMobile"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    today() {
      return new Date();
    },
  },
};
</script>

<style>
.date-container {
  width: 100%;
  flex-grow: 3;
}

.datetimepicker.is-dark .datepicker,
.datetimepicker.is-dark .pickers-container {
  background-color: #101114 !important;
  border-bottom: 1px solid #fff !important;
}

.year-month-selector.dark[data-v-4a0f7afa] {
  background-color: #101114 !important;
}

.custom-button.is-dark[data-v-2ed8e606] {
  background-color: #101114 !important;
  border: 1px solid #fff !important;
}

@media (max-width:450px) {
.datetimepicker:not(.inline) .datepicker[data-v-17c053f2] {
	padding-top: 120px;
}
}
</style>
